let containerSelector;
const setGlTooltipDefaultContainer = selector => {
  containerSelector = selector;
};
const getGlTooltipDefaultContainer = () => containerSelector;

export { getGlTooltipDefaultContainer, setGlTooltipDefaultContainer };
